function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Undo = e() : t.Undo = e();
}(self, function () {
  return function () {
    "use strict";

    var t = {
      d: function d(e, n) {
        for (var i in n) {
          t.o(n, i) && !t.o(e, i) && Object.defineProperty(e, i, {
            enumerable: !0,
            get: n[i]
          });
        }
      },
      o: function o(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }
    },
        e = {};

    function n(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    t.d(e, {
      default: function _default() {
        return s;
      }
    });

    var i = function () {
      function t(e, n) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.holder = n, this.observer = null, this.debounceTimer = 200, this.mutationDebouncer = this.debounce(function () {
          e();
        }, this.debounceTimer);
      }

      var e, i;
      return e = t, i = [{
        key: "setMutationObserver",
        value: function value() {
          var t = this,
              e = this.holder;
          this.observer = new MutationObserver(function (e) {
            t.mutationHandler(e);
          }), this.observer.observe(e, {
            childList: !0,
            attributes: !0,
            subtree: !0,
            characterData: !0,
            characterDataOldValue: !0
          });
        }
      }, {
        key: "mutationHandler",
        value: function value(t) {
          var e = this,
              n = !1;
          t.forEach(function (t) {
            switch (t.type) {
              case "childList":
                t.target === e.holder ? e.onDestroy() : n = !0;
                break;

              case "characterData":
                n = !0;
                break;

              case "attributes":
                t.target.classList.contains("ce-block") || (n = !0);
            }
          }), n && this.mutationDebouncer();
        }
      }, {
        key: "debounce",
        value: function value(t, e) {
          var n,
              i = this;
          return function () {
            for (var o = arguments.length, s = new Array(o), r = 0; r < o; r++) {
              s[r] = arguments[r];
            }

            var a = i;
            clearTimeout(n), n = setTimeout(function () {
              return t.apply(a, s);
            }, e);
          };
        }
      }, {
        key: "onDestroy",
        value: function value() {
          var t = new CustomEvent("destroy");
          document.dispatchEvent(t), this.observer.disconnect();
        }
      }], i && n(e.prototype, i), t;
    }();

    function o(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var s = function () {
      function t(e) {
        var n = this,
            o = e.editor,
            s = e.config,
            r = void 0 === s ? {} : s,
            a = e.onUpdate,
            c = e.maxLength;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var h = {
          maxLength: 30,
          onUpdate: function onUpdate() {},
          config: {
            shortcuts: {
              undo: "CMD+Z",
              redo: "CMD+Y"
            }
          }
        },
            u = o.configuration,
            l = u.holder,
            d = h.config.shortcuts,
            f = r.shortcuts,
            v = void 0 === f ? d : f;
        this.holder = "string" == typeof l ? document.getElementById(l) : l, this.editor = o, this.shouldSaveHistory = !0, this.readOnly = u.readOnly, this.maxLength = c || h.maxLength, this.onUpdate = a || h.onUpdate, this.config = {
          shortcuts: v
        }, new i(function () {
          return n.registerChange();
        }, this.holder).setMutationObserver(), this.setEventListeners(), this.initialItem = null, this.clear();
      }

      var e, n, s;
      return e = t, s = [{
        key: "isReadOnlySupported",
        get: function get() {
          return !0;
        }
      }], (n = [{
        key: "truncate",
        value: function value(t, e) {
          for (; t.length > e;) {
            t.shift();
          }
        }
      }, {
        key: "initialize",
        value: function value(t) {
          var e = "blocks" in t ? t.blocks : t,
              n = {
            index: e.length - 1,
            state: e
          };
          this.stack[0] = n, this.initialItem = n;
        }
      }, {
        key: "clear",
        value: function value() {
          this.stack = this.initialItem ? [this.initialItem] : [{
            index: 0,
            state: [{
              type: "paragraph",
              data: {
                text: ""
              }
            }]
          }], this.position = 0, this.onUpdate();
        }
      }, {
        key: "registerChange",
        value: function value() {
          var t = this;
          this.readOnly || (this.editor && this.editor.save && this.shouldSaveHistory && this.editor.save().then(function (e) {
            t.editorDidUpdate(e.blocks) && t.save(e.blocks);
          }), this.shouldSaveHistory = !0);
        }
      }, {
        key: "editorDidUpdate",
        value: function value(t) {
          var e = this.stack[this.position].state;
          return !!t.length && (t.length !== e.length || JSON.stringify(e) !== JSON.stringify(t));
        }
      }, {
        key: "save",
        value: function value(t) {
          this.position >= this.maxLength && this.truncate(this.stack, this.maxLength), this.position = Math.min(this.position, this.stack.length - 1), this.stack = this.stack.slice(0, this.position + 1);
          var e = this.editor.blocks.getCurrentBlockIndex();
          this.stack.push({
            index: e,
            state: t
          }), this.position += 1, this.onUpdate();
        }
      }, {
        key: "undo",
        value: function value() {
          var t = this;

          if (this.canUndo()) {
            this.shouldSaveHistory = !1;
            var e = this.stack[this.position -= 1],
                n = e.index,
                i = e.state;
            this.onUpdate(), this.editor.blocks.render({
              blocks: i
            }).then(function () {
              return t.editor.caret.setToBlock(n, "end");
            });
          }
        }
      }, {
        key: "redo",
        value: function value() {
          var t = this;

          if (this.canRedo()) {
            this.shouldSaveHistory = !1;
            var e = this.stack[this.position += 1],
                n = e.index,
                i = e.state;
            this.onUpdate(), this.editor.blocks.render({
              blocks: i
            }).then(function () {
              return t.editor.caret.setToBlock(n, "end");
            });
          }
        }
      }, {
        key: "canUndo",
        value: function value() {
          return !this.readOnly && this.position > 0;
        }
      }, {
        key: "canRedo",
        value: function value() {
          return !this.readOnly && this.position < this.count();
        }
      }, {
        key: "count",
        value: function value() {
          return this.stack.length - 1;
        }
      }, {
        key: "parseKeys",
        value: function value(t) {
          var e = {
            CMD: /(Mac)/i.test(navigator.platform) ? "metaKey" : "ctrlKey",
            ALT: "altKey",
            SHIFT: "shiftKey"
          },
              n = t.slice(0, -1).map(function (t) {
            return e[t];
          }),
              i = n.includes("shiftKey") ? t[t.length - 1].toUpperCase() : t[t.length - 1].toLowerCase();
          return n.push(i), n;
        }
      }, {
        key: "setEventListeners",
        value: function value() {
          var t = this,
              e = this.holder,
              n = this.config.shortcuts,
              i = n.undo,
              o = n.redo,
              s = i.replace(/ /g, "").split("+"),
              r = o.replace(/ /g, "").split("+"),
              a = this.parseKeys(s),
              c = this.parseKeys(r),
              h = function h(t, e) {
            return !(2 !== e.length || !t[e[0]] || t.key !== e[1]) || !(3 !== e.length || !t[e[0]] || !t[e[1]] || t.key !== e[2]);
          },
              u = function u(e) {
            h(e, a) && (e.preventDefault(), t.undo());
          },
              l = function l(e) {
            h(e, c) && (e.preventDefault(), t.redo());
          };

          e.addEventListener("keydown", u), e.addEventListener("keydown", l), e.addEventListener("destroy", function () {
            e.removeEventListener("keydown", u), e.removeEventListener("keydown", l);
          });
        }
      }]) && o(e.prototype, n), s && o(e, s), t;
    }();

    return e.default;
  }();
});